module.exports = __webpack_public_path__ + "static/media/gas cylinder_1.9442ca6d.png";